import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Checkbox, Typography, Divider, List, ListItem } from '@mui/material';
import { MessagesForTopicProps } from '../../../../types/summarizeTable';
import { SummarizeContainer, SummarizeFormControlLabel } from './SummarizeTable.styles';
const MessagesForTopic: React.FC<MessagesForTopicProps> = ({ topics, onSelectAll, onSelectTopic }) => {
  const { t } = useTranslation('optimizer');
  const [selectedTopics, setSelectedTopics] = useState<Record<string, boolean>>(
    Object.fromEntries(topics.map(topic => [topic, false])),
  );
  const allSelected = Object.values(selectedTopics).every(Boolean);
  const handleToggleAll = () => {
    const newValue = !allSelected;
    const updated = Object.fromEntries(topics.map(topic => [topic, newValue]));
    setSelectedTopics(updated);
    onSelectAll(newValue);
  };
  const handleTopicChange = (topic: string) => {
    setSelectedTopics(prev => {
      const newSelected = !prev[topic];
      const updated = { ...prev, [topic]: newSelected };
      onSelectTopic(topic, newSelected);
      return updated;
    });
  };
  return (
    <SummarizeContainer optVariant="messageForTopic">
      <SummarizeContainer optVariant="heading">
        <SummarizeFormControlLabel
          control={
            <Checkbox
              checked={allSelected}
              onChange={handleToggleAll}
            />
          }
          label={<Typography variant="h6">{t('summarize.selectAllChats')}</Typography>}
        />
        <Divider />
      </SummarizeContainer>
      <List disablePadding>
        {topics.map(topic => (
          <ListItem key={topic} disablePadding>
            <SummarizeContainer optVariant="optimization">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedTopics[topic]}
                    onChange={() => handleTopicChange(topic)}
                  />
                }
                label={topic}
              />
            </SummarizeContainer>
          </ListItem>
        ))}
      </List>
    </SummarizeContainer>
  );
};
export default MessagesForTopic;
